import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-696bc0c4")

_pushScopeId("data-v-696bc0c4")
const _hoisted_1 = /*#__PURE__*/_createVNode("h1", { class: "page-name" }, "ユーザーマスタ保守", -1)
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "p-field p-grid" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  for: "title",
  class: "p-col-12 p-mb-2 p-md-2 p-mb-0"
}, " ユーザー名 ", -1)
const _hoisted_7 = { class: "p-col-10 p-mb-10" }
const _hoisted_8 = { class: "p-field p-grid" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  for: "title",
  class: "p-col-12 p-mb-2 p-md-2 p-mb-0"
}, " 有効区分 ", -1)
const _hoisted_10 = { class: "p-col-6 p-md-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { for: "rb_Yukokb1" }, "有効のみ", -1)
const _hoisted_12 = { class: "p-col-6 p-md-2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { for: "rb_Yukokb99" }, "全て", -1)
const _hoisted_14 = { class: "p-d-flex p-jc-end" }
const _hoisted_15 = { class: "card" }
const _hoisted_16 = { class: "table-header" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 編集 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OJ7091F = _resolveComponent("OJ7091F")
  const _component_InputText = _resolveComponent("InputText")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Button = _resolveComponent("Button")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_OJ7091F, { ref: "OJ7091F" }, null, 512),
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.mRefUSERNM,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mRefUSERNM = $event)),
                type: "text",
                class: "p-inputtext p-component",
                style: {"width":"200px"}
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_RadioButton, {
                id: "rb_Yukokb1",
                name: "rb_Yukokb",
                value: 1,
                modelValue: _ctx.mRefYUKOKB,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.mRefYUKOKB = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_11
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_RadioButton, {
                id: "rb_Yukokb99",
                name: "rb_Yukokb",
                value: 99,
                modelValue: _ctx.mRefYUKOKB,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.mRefYUKOKB = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_13
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_Button, {
            label: "クリア",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fncClearButton())),
            class: "p-button",
            style: {"margin-right":"10px"}
          }),
          _createVNode(_component_Button, {
            label: "検索",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.fncGetList())),
            class: "p-button"
          })
        ])
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode(_component_DataTable, {
          value: _ctx.mDgList,
          dataKey: "USERKY",
          class: "p-datatable-striped p-datatable-gridlines p-datatable-sm p-datatable-responsive p-datatable-customers",
          loading: _ctx.loadingFlg,
          paginator: true,
          rows: 30,
          scrollable: true,
          paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
          currentPageReportTemplate: "{totalRecords}件中 {first}件〜{last}件を表示"
        }, {
          header: _withId(() => [
            _createVNode("div", _hoisted_16, [
              _createVNode(_component_Button, {
                label: "新規",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fncShowShosai(0))),
                class: "p-button normal-button p-mr-2 p-mb*2"
              })
            ])
          ]),
          default: _withId(() => [
            _createVNode(_component_Column, {
              field: "USERID",
              header: "ID",
              headerStyle: "",
              sortable: true
            }),
            _createVNode(_component_Column, {
              field: "USERNM",
              header: "ユーザー名",
              headerStyle: "",
              sortable: true
            }),
            _createVNode(_component_Column, {
              field: "KEGENM2",
              header: "権限",
              headerStyle: "",
              sortable: true
            }),
            _createVNode(_component_Column, {
              field: "DISPNM",
              header: "有効",
              headerStyle: "width: 80px;",
              bodyStyle: "text-align: center;width: 80px;",
              sortable: true
            }),
            _createVNode(_component_Column, {
              header: "コマンド",
              headerStyle: "width: 100px;",
              headerClass: "frozen-column",
              bodyStyle: "text-align: center;width: 100px;",
              bodyClass: "frozen-column"
            }, {
              body: _withId((row) => [
                _createVNode(_component_Button, {
                  onClick: ($event: any) => (_ctx.fncShowShosai(row.data.USERKY)),
                  type: "button",
                  class: "p-button-success"
                }, {
                  default: _withId(() => [
                    _hoisted_17
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "loading"])
      ])
    ])
  ], 64))
})